/*! MakNorte Perf - lazy + srcset trim mobile */
(function(){
  function enforceLazy(){
    const fold=window.innerHeight+200;
    document.querySelectorAll('img').forEach(img=>{
      const r=img.getBoundingClientRect();
      if(r.top>fold&&img.loading!=='lazy')img.loading='lazy';
    });
  }
  function trimSrcset(){
    const isMobile=window.innerWidth<750;
    const maxWidth=isMobile?1200:2560;
    document.querySelectorAll('img[srcset]').forEach(img=>{
      const src=img.getAttribute('srcset');if(!src)return;
      const parts=src.split(',').map(p=>p.trim()).filter(p=>{
        const m=p.match(/\s(\d+)w/);if(!m)return true;
        return parseInt(m[1])<=maxWidth;
      });
      img.setAttribute('srcset',parts.join(', '));
    });
  }
  function run(){enforceLazy();trimSrcset();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
